import { observable, action, computed, makeObservable } from "mobx";
import Utility from "../common/utility";
import ApiCalls from "../components/apis/api-calls";
import config from "../config/config";
const initialState = {
  loaderCount: 0,
  userRole: "",
  membersData: [],
  timezoneData: [],
  isShowInviteeModal: "",
  tempPassword: "",
  profileData: {},
  username: "",
  invoicesData: [],
  paymentArr: [],
  bankArr: [],
  licenseData: {},
  selectedInvoice: {},
  companyLicenseType: "",
  customerSeriesType: "",
  isCustomPayment: false,
  versionArr: [],
  versionData: {},
  downloadData: {},
  selectedCurrentVersion: null,
  previousCurrentVersion: null,
  currentVersionDate: "",
  banner_notification: true,
  numberOfLicenses: {},
  versionOptions: [],
  customVersionOptions: [],
  toogleIcon: false
};

class SharedStore {
  constructor() {
    makeObservable(this, {
      loaderCount: observable,
      showLoginDropdown: observable,
      username: observable,
      isOnLoginPage: observable,
      userRole: observable,
      membersData: observable,
      timezoneData: observable,
      isShowInviteeModal: observable,
      tempPassword: observable,
      profileData: observable,
      invoicesData: observable,
      paymentArr: observable,
      bankArr: observable,
      selectedInvoice: observable,
      licenseData: observable,
      companyLicenseType: observable,
      customerSeriesType: observable,
      isCustomPayment: observable,
      versionArr: observable,
      versionData: observable,
      downloadData: observable,
      selectedCurrentVersion: observable,
      previousCurrentVersion: observable,
      currentVersionDate: observable,
      banner_notification: observable,
      numberOfLicenses: observable,
      versionOptions: observable,
      customVersionOptions: observable,
      pdfId: observable,
      pdfKey: observable,
      file: observable,
      toogleIcon: observable,
      setDownloadsData: action,
      setLoginDropDown: action,
      setToogleIcon: action,
      showLoader: action,
      hideLoader: action,
      reset: action,
      isShowLoader: computed,
      payableAmount: computed,
      setUserRole: action,
      removeUserRole: action,
      setMembersData: action,
      setTimeZoneData: action,
      setUsername: action,
      removeMembersData: action,
      removeTimeZoneData: action,
      setShowInviteeModel: action,
      getShowInviteeModel: action,
      removeTempPassword: action,
      setProfileData: action,
      setInvoiceData: action,
      setLicenseData: action,
      clearLicenseData: action,
      setSelectedInvoice: action,
      clearInvoiceData: action,
      setPaymentData: action,
      clearPaymentData: action,
      setBankData: action,
      clearBankData: action,
      clearSelectedInvoice: action,
      setCompanyLicenseType: action,
      setCustomerSeriesType: action,
      setCustomPaymentValue: action,
      setVersionArr: action,
      setVersionData: action,
      setSelectedCurrentVersion: action,
      setSelectedPreviousVersion: action,
      setCurrentVersionDate: action,
      showBanner: action,
      resetAllData: action,
      getMemebersData: action,
      getLicenseData: action,
      fetchInvoiceList: action,
      updatePdfFile: action,
      logInvoice: action,
      fetchBank: action,
      fetchCard: action,
      fetchNumberOfLicenses: action,
      postVersionOptions: action,
      getVersionOptions: action
    });

    this.load();
  }

  load() {
    let sharedStoreData = Utility.getData("sharedStore");
    if (sharedStoreData) {
      this.userRole = sharedStoreData.userRole;
      this.username = sharedStoreData.username;
      this.membersData = sharedStoreData.membersData;
      this.toogleIcon = sharedStoreData.toogleIcon;
      this.timezoneData = sharedStoreData.timezoneData;
      this.isShowInviteeModal = sharedStoreData.isShowInviteeModal;
      this.tempPassword = sharedStoreData.tempPassword;
      this.profileData = sharedStoreData.profileData;
      this.invoicesData = sharedStoreData.invoicesData;
      this.paymentArr = sharedStoreData.paymentArr;
      this.bankArr = sharedStoreData.bankArr;
      this.licenseData = sharedStoreData.licenseData;
      this.selectedInvoice = sharedStoreData.selectedInvoice;
      this.companyLicenseType = sharedStoreData.companyLicenseType;
      this.customerSeriesType = sharedStoreData.customerSeriesType;
      this.isCustomPayment = sharedStoreData.isCustomPayment;
      this.versionArr = sharedStoreData.versionArr;
      this.versionData = sharedStoreData.versionData;
      this.downloadData = sharedStoreData.downloadData;
      this.banner_notification = sharedStoreData.banner_notification;
      this.numberOfLicenses = sharedStoreData.numberOfLicenses;
      this.versionOptions = sharedStoreData.versionOptions;
      this.customVersionOptions = sharedStoreData.customVersionOptions;
    }
  }

  loaderCount = initialState.loaderCount;
  showLoginDropdown = false;
  username = initialState.username;
  isOnLoginPage = false;
  userRole = initialState.userRole;
  membersData = initialState.membersData;
  timezoneData = initialState.timezoneData;
  isShowInviteeModal = initialState.isShowInviteeModal;
  tempPassword = initialState.tempPassword;
  profileData = initialState.profileData;
  invoicesData = initialState.invoicesData;
  paymentArr = initialState.paymentArr;
  bankArr = initialState.bankArr;
  selectedInvoice = initialState.selectedInvoice;
  licenseData = [];
  companyLicenseType = initialState.companyLicenseType;
  customerSeriesType = initialState.customerSeriesType;
  isCustomPayment = initialState.isCustomPayment;
  versionArr = initialState.versionArr;
  versionData = initialState.versionData;
  downloadData = initialState.downloadData;
  selectedCurrentVersion = initialState.selectedCurrentVersion;
  previousCurrentVersion = initialState.previousCurrentVersion;
  currentVersionDate = initialState.currentVersionDate;
  banner_notification = initialState.banner_notification;
  numberOfLicenses = initialState.numberOfLicenses;
  versionOptions = initialState.versionOptions;
  customVersionOptions = initialState.customVersionOptions;
  toogleIcon = initialState.toogleIcon;
  pdfId = "";
  pdfKey = "";
  file = "";

  setLoginDropDown(value) {
    this.showLoginDropdown = value;
  }

  setToogleIcon = value => {
    this.toogleIcon = value;
  };

  setTick = value => {
    this.tick = value;
  };

  showLoader() {
    this.loaderCount++;
  }

  hideLoader() {
    if (this.loaderCount !== 0) {
      this.loaderCount--;
    }
  }

  reset() {
    this.loaderCount = initialState.loaderCount;
  }

  get payableAmount() {
    let invoiceList = [];
    this.invoicesData &&
      this.invoicesData.map((data, index) => {
        invoiceList.push(data);
      });
    let payableAmount = 0.0;
    invoiceList.map(invoice => {
      if (!invoice.is_paid || invoice.is_paid === 3) {
        payableAmount +=
          invoice.open_balance != null
            ? invoice.open_balance
            : invoice.balance_due;
      }
    });
    return payableAmount;
  }

  get isShowLoader() {
    if (this.loaderCount <= 0) {
      return false;
    }
    return true;
  }

  setUserRole(roleId) {
    this.userRole = roleId;
  }

  removeUserRole() {
    this.userRole = initialState.userRole;
  }

  setMembersData(data) {
    this.membersData = data;
  }

  setTimeZoneData(data) {
    this.timezoneData = data;
  }

  setUsername(username) {
    this.username = username;
  }

  removeMembersData() {
    this.membersData = [];
  }

  removeTimeZoneData() {
    this.timezoneData = [];
  }

  setShowInviteeModel(key, tempPassword) {
    this.isShowInviteeModal = key === "pending" ? true : false;
    this.tempPassword = tempPassword;
  }

  getShowInviteeModel() {
    return this.isShowInviteeModal;
  }

  removeTempPassword() {
    this.isShowInviteeModal = "";
    this.tempPassword = "";
  }

  setProfileData(data) {
    this.profileData = data;
  }

  setInvoiceData(data) {
    this.invoicesData = data;
  }

  setLicenseData(data) {
    this.licenseData = data;
  }

  clearLicenseData() {
    this.licenseData = {};
  }

  setSelectedInvoice(invoice) {
    this.selectedInvoice = invoice;
  }

  clearInvoiceData() {
    this.invoicesData = [];
  }

  setPaymentData(cardArr) {
    this.paymentArr = cardArr;
  }

  clearPaymentData() {
    this.paymentArr = [];
  }

  setBankData(cardArr) {
    this.bankArr = cardArr;
  }

  clearBankData() {
    this.bankArr = [];
  }

  clearSelectedInvoice() {
    this.selectedInvoice = {};
  }

  setCompanyLicenseType(type) {
    this.companyLicenseType = type;
  }

  setCustomerSeriesType(type) {
    this.customerSeriesType = type;
  }

  setCustomPaymentValue(value) {
    this.isCustomPayment = value;
  }

  setVersionArr(value) {
    this.versionArr = value;
  }

  setVersionData(value) {
    this.versionData = value;
  }

  setDownloadsData(value) {
    this.downloadData = value;
  }

  setSelectedCurrentVersion(value) {
    this.selectedCurrentVersion = value;
  }

  setSelectedPreviousVersion(value) {
    this.previousCurrentVersion = value;
  }

  setCurrentVersionDate(value) {
    this.currentVersionDate = value;
  }

  showBanner(flag) {
    this.banner_notification = flag;
  }

  resetAllData() {
    Utility.clearData("companyName");
    Utility.clearData("userId");
    Utility.clearData("companyId");
    this.userRole = initialState.userRole;
    this.username = initialState.username;
    this.membersData = initialState.membersData;
    this.timezoneData = initialState.timezoneData;
    this.isShowInviteeModal = initialState.isShowInviteeModal;
    this.tempPassword = initialState.tempPassword;
    this.profileData = initialState.profileData;
    this.invoicesData = initialState.invoicesData;
    this.paymentArr = initialState.paymentArr;
    this.bankArr = initialState.bankArr;
    this.licenseData = initialState.licenseData;
    this.selectedInvoice = initialState.selectedInvoice;
    this.companyLicenseType = initialState.companyLicenseType;
    this.customerSeriesType = initialState.customerSeriesType;
    this.isCustomPayment = initialState.isCustomPayment;
    this.versionArr = initialState.versionArr;
    this.versionData = initialState.versionData;
    this.downloadData = initialState.downloadData;
    this.banner_notification = initialState.banner_notification;
  }

  getLicenseData() {
    this.setCompanyLicenseType("");
    this.showLoader();
    return ApiCalls.getLicenseInfo().then(json => {
      this.hideLoader();
      if (json && json.error === false) {
        this.setLicenseData(json.data);
        if (json.data.license_mode === "Online") {
          if (json.data.subCompanies.length > 0) {
            const subCompanies = json.data.subCompanies;
            for (let i = 0; i < subCompanies.length; i++) {
              if (!subCompanies[i].onlineMode) {
                this.setCompanyLicenseType("Offline");
                break;
              }
            }
          } else {
            this.setCompanyLicenseType("Online");
          }
        } else {
          this.setCompanyLicenseType("Offline");
        }
      } else {
        this.clearLicenseData();
      }
    });
  }

  getMemebersData() {
    this.showLoader();
    return ApiCalls.getMemberInfo()
      .then(response => {
        this.hideLoader();
        if (response && response.error === false) {
          this.setMembersData(response.data);
        }
      })
      .catch(err => {
        this.hideLoader();
      });
  }

  cancelInvitation(userId) {
    this.showLoader();
    return ApiCalls.cancelInvitation({ userId: userId })
      .then(response => {
        this.hideLoader();
        if (response && response.error === false) {
          this.getMemebersData();
        }
      })
      .catch(err => {
        this.hideLoader();
      });
  }

  fetchResources(params = "") {
    this.showLoader();
    ApiCalls.fetchResources(params)
      .then(res => {
        this.hideLoader();
        if (params === "" && res && res.data) {
          this.setVersionArr(res.data.version);
        }
      })
      .catch(err => {
        this.hideLoader();
        console.log("err", err);
      });
  }

  fetchVersion() {
    this.showLoader();
    ApiCalls.fetchVersion()
      .then(res => {
        this.hideLoader();
        this.setVersionData(res.data);
      })
      .catch(err => {
        this.hideLoader();
        console.log("err", err);
      });
  }

  getCurrentVersion() {
    this.showLoader();
    ApiCalls.getCurrentVersion()
      .then(res => {
        this.hideLoader();
        if (res.status_code === 200) {
          this.setSelectedCurrentVersion(res.data.izenda_version);
          this.setSelectedPreviousVersion(res.data.izenda_version);
          this.setCurrentVersionDate(res.data.updated_at);
        } else {
          this.setSelectedCurrentVersion(-1);
          this.setSelectedPreviousVersion(-1);
          this.setCurrentVersionDate("");
        }
      })
      .catch(err => {
        this.hideLoader();
        console.log("err", err);
      });
  }

  fetchInvoiceList() {
    this.showLoader();
    ApiCalls.getInvoicesList({
      userRole: this.userRole,
      companyId: Utility.getData("companyId")
    }).then(res => {
      this.hideLoader();
      if (res && res.responseCode === 200) {
        if (res.data && res.data.result.length > 0) {
          let arr = [];
          res.data.result
            .filter(data => data.is_paid === 0 || data.is_paid === 3)
            .map(newVal => arr.push(newVal.header));
          // let check = constant.checklist.some((r) => arr.indexOf(r) >= 0);
          // this.setHeader(check);
          this.setInvoiceData(res.data.result);
          this.setSelectedInvoice(res.data.result[0]);
          this.setCustomPaymentValue(res.is_custom_payment_enabled);
          this.pdfId = res.data.result[0].invoice_id;
          this.pdfKey = res.data.result[0].s3Key;
          this.file = `${config.baseURL}/backend/fetchInvoice?key=${
            this.pdfKey
          }`;
        }
      }
    });
  }

  logInvoice = pdfId => {
    const userId = Utility.getData("userId");
    return ApiCalls.logInvoice({ user_id: userId, invoice_id: pdfId })
      .then(res => {})
      .catch(err => {
        console.log("err", err);
      });
  };

  getVersionOptions = version => {
    return ApiCalls.fetchVersionOptions(version)
      .then(res => {
        if (res && res.status_code === 200) {
          this.versionOptions = res.data;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  };

  getCustomVersionOptions = version => {
    return ApiCalls.fetchVersionOptions(version)
      .then(res => {
        if (res && res.status_code === 200) {
          console.log("THE STUFF", res.data);
          this.customVersionOptions = res.data;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  };

  postVersionOptions = (optionArr, version) => {
    return ApiCalls.postVersionOptions({ options: optionArr, version: version })
      .then(res => {
        if (res && res.status_code === 200) {
          this.versionOptions = res.data;
          this.getVersionOptions(version);
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  };

  postCustomVersionOptions = (optionArr, version) => {
    return ApiCalls.postVersionOptions({ options: optionArr, version: version })
      .then(res => {
        if (res && res.status_code === 200) {
          this.customVersionOptions = res.data;
          this.getCustomVersionOptions(version);
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  };

  updatePdfFile = invoice => {
    if (this.pdfId !== invoice.invoice_id) {
      this.pdfId = invoice.invoice_id;
      this.logInvoice(this.pdfId);
      this.pdfKey = invoice.s3Key;
      this.file = `${config.baseURL}/backend/fetchInvoice?key=${this.pdfKey}`;
      this.setSelectedInvoice(invoice);
    }
  };

  fetchCard = () => {
    ApiCalls.fetchCard()
      .then(cardObj => {
        if (cardObj && cardObj.error === false) {
          if (cardObj.data && cardObj.data.length > 0) {
            this.setPaymentData(cardObj.data);
          } else {
            this.clearPaymentData();
          }
        }
      })
      .catch(err => console.log("err", err));
  };

  fetchBank = () => {
    ApiCalls.fetchBank()
      .then(bankObj => {
        if (bankObj && bankObj.error === false) {
          if (bankObj.data && bankObj.data.length > 0) {
            this.setBankData(bankObj.data);
          } else {
            this.clearBankData();
          }
        }
      })
      .catch(err => console.log("err", err));
  };

  fetchNumberOfLicenses = params => {
    ApiCalls.fetchNumberOfLicenses(params)
      .then(res => {
        if ((res.status_code = 200)) {
          this.numberOfLicenses = res;
          // this.subLicenseGenerationEnabled = res.creation_allowed;
        } else {
          this.numberOfLicenses = {};
          // this.subLicenseGenerationEnabled = false;
        }
      })
      .catch(error => {
        console.log(error);
        this.numberOfLicenses = {};
        // this.subLicenseGenerationEnabled = false;
      });
  };
}

export default SharedStore;



// WEBPACK FOOTER //
// ./src/stores/SharedStore.js